import { InvestorDocumentWorkflowWitnessRes } from '@dealstack/shared/lib/generated';
import {
	CHIP_THEME,
	COLOR,
	Chips as ChipsV2,
} from '@dealstack/frontend/shared/components/Chips/Chips.v2';

export const WitnessChip = (witness: InvestorDocumentWorkflowWitnessRes | null | undefined) => {
	if (!witness) {
		return null;
	}
	const signed = witness.signedCount >= witness.requiredCount;
	return (
		<ChipsV2
			outline
			size="s"
			color={signed ? COLOR.GREEN : COLOR.YELLOW}
			chipTheme={CHIP_THEME.LIGHT}
		>
			{`Witness ${witness.signedCount}/${witness.requiredCount}`}
		</ChipsV2>
	);
};
